import { ArrowRight, ICON_STROKE_WIDTH } from './Icon';

type RollingButtonProps = {
  children: string;
  onClick?: () => void;
  variant?: 'primary' | 'dark' | 'light';
  className?: string;
  type?: 'button' | 'submit';
  disabled?: boolean;
  dataOdId?: string;
};

const variants = {
  primary: 'bg-[var(--accent)] text-white hover:bg-[var(--accent-strong)] shadow-[0_12px_28px_color-mix(in_oklch,var(--accent)_26%,transparent)]',
  dark: 'bg-[var(--fg)] text-white hover:bg-black shadow-[0_12px_28px_rgba(17,24,39,.18)]',
  light: 'bg-white text-[var(--fg)] hover:bg-[var(--bg)] shadow-[0_10px_24px_rgba(17,24,39,.1)]',
};

export function RollingButton({
  children,
  onClick,
  variant = 'primary',
  className = '',
  type = 'button',
  disabled = false,
  dataOdId,
}: RollingButtonProps) {
  const arrowClass = variant === 'light' ? 'bg-[var(--fg)] text-white' : 'bg-white text-[var(--accent)]';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      data-od-id={dataOdId}
      className={`group inline-flex min-h-11 items-center gap-3 rounded-full py-2 pl-5 pr-2 text-[13px] font-semibold transition-all duration-500 ease-[cubic-bezier(0.25,0.1,0.25,1)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 sm:pl-6 ${variants[variant]} ${className}`}
    >
      <span className="relative h-5 overflow-hidden leading-5">
        <span className="flex flex-col transition-transform duration-500 ease-[cubic-bezier(0.25,0.1,0.25,1)] motion-safe:group-hover:-translate-y-1/2">
          <span>{children}</span>
          <span aria-hidden="true">{children}</span>
        </span>
      </span>
      <span className={`grid h-8 w-8 shrink-0 place-items-center rounded-full ${arrowClass}`}>
        <ArrowRight className="h-4 w-4 transition-transform duration-500 ease-[cubic-bezier(0.25,0.1,0.25,1)] motion-safe:-rotate-45 motion-safe:group-hover:rotate-0" strokeWidth={ICON_STROKE_WIDTH} aria-hidden="true" />
      </span>
    </button>
  );
}
